import { createAppStore } from '@store/createAppStore';
import {
  ATGDormantPoolDataType,
  DormantPoolGridType,
  DormantPoolStoreType,
} from '@typeDefinitions/dormantPoolTypes';

const initialGridView: DormantPoolGridType = {
  data: [],
  originStates: [],
  destinationStates: [],
  equipment: [],
};

const initialATGData: ATGDormantPoolDataType = {
  customer: {
    dormantCustomerReturnComments: [],
  },
  states: {},
  provinces: {},
  carrier: {
    equipmentOptions: [],
  },
};

const [dormatPoolStore, setDormantPoolStore] =
  createAppStore<DormantPoolStoreType>(
    {
      poolSize: 0,
      claimed: [],
      gridView: initialGridView,
      ATGData: initialATGData,
    },
    'dormatPoolStore',
  );

export { dormatPoolStore, setDormantPoolStore };
